module.exports = __webpack_public_path__ + "img/visibility_off_black_24dp.20c2d0a0.png";